<template>
  <tr :class="{'clickable': $can('edit', 'Owner')}">
    <td>
      {{ owner.id }}
    </td>
    <td>
      {{ owner.name }}
    </td>
    <td>
      <span v-if="owner.yachts.length > 0">
        <v-chip
          v-for="yacht in owner.yachts"
          :key="yacht.id"
          outlined
          small
          :to="{ name: 'yachtDashboard', params: { id: yacht.id }}"
          target="_blank"
          @click.stop
        >
          #{{ yacht.id }} &middot; {{ yacht.name || 'No Name' }}
        </v-chip>
      </span>
      <span
        v-else
        class="grey--text"
      >
        N/A
      </span>
    </td>
    <td>
      {{ owner.contact_details.email }}
    </td>
    <td>
      {{ owner.contact_details.phone }}
    </td>
    <td>
      <v-chip
        class="ma-0"
        small
        label
        color="transparent"
        :text-color="owner.has_user ? 'success' : 'error'"
      >
        <v-avatar>
          <v-icon
            style="font-size: 14px"
            :color="owner.has_user ? 'success' : 'error'"
          >
            {{ owner.has_user ? 'fa fa-check' : 'fa fa-times' }}
          </v-icon>
        </v-avatar>
        {{ owner.has_user ? 'Yes' : 'No' }}
      </v-chip>
    </td>
    <td>
      {{ owner.country.name }}
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'OwnerRow',
    props: {
      owner: {
        type: Object,
        default: () => null
      }
    }
  }
</script>
